<template>
  <div class="drop-area" ref="dropArea">
    <slot></slot>
  </div>
</template>
<script>
import { DropAreas } from "@eds/vanilla";
import dragula from "dragula";

export default {
  mounted() {
    const dropAreas = new DropAreas([this.$refs.dropArea]);
    dropAreas.init();

    this.$nextTick(() => {
      dragula([this.$refs.dropArea])
      .on('dragend', () => {
        this.$nextTick(() => {
          this.syncDropItems();
        });
      });
    });
  },
  methods: {
    syncDropItems() {
      const items = Array.from(this.$refs.dropArea.children).map((child) => {
        const index = child.getAttribute("data-index");
        return { index: parseInt(index) };
      });
      this.$emit("reorder", items);
    }
  }
};
</script>